import { render, staticRenderFns } from "./ProjectBudgetDecrease.vue?vue&type=template&id=d8ec395a"
import script from "./ProjectBudgetDecrease.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetDecrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports